var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_63","data-name":"Ellipse 63","cx":"20","cy":"20","r":"20","fill":"#a1daf8","key":0}),React.createElement("path",{"id":"Icon_awesome-linkedin-in","data-name":"Icon awesome-linkedin-in","d":"M4.569,20.412H.337V6.784H4.569ZM2.451,4.925A2.462,2.462,0,1,1,4.9,2.451,2.471,2.471,0,0,1,2.451,4.925ZM20.407,20.412H16.184V13.778c0-1.581-.032-3.608-2.2-3.608-2.2,0-2.537,1.718-2.537,3.495v6.748H7.22V6.784h4.059V8.643h.059a4.447,4.447,0,0,1,4-2.2c4.283,0,5.07,2.82,5.07,6.483v7.486Z","transform":"translate(9.902 9.686)","fill":"#1d1d1d","key":1})]);
}

SocialLinkedin.defaultProps = {"id":"Linkedin","width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
